// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileMatchPeriodIcon_root___xXFa","matchPeriod":"MobileMatchPeriodIcon_matchPeriod__A3jWG"};